import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 申领状态
 */
class State extends UltMeta {
    CLAIMING = new Meta(1, "待处理");
    CLAIMED = new Meta(2, "已完成");
}

export const STATE = new State();
